import React, {Component} from 'react';
import {
    Select, Spin, Badge, Popover
} from 'antd';

//Config locate
import moment from 'moment';
import 'moment/locale/vi';

moment.locale('vi');
export default class SelectDevices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            data: [],
            devices: [],
            deDevices: [],
            firstLoad: true,
        }
    }

    componentWillMount() {
        if (this.props.clientID && this.props.clientID > 0) {
            this.fetchDevices(this.props.clientID);
        }
    }

    componentWillReceiveProps(nextProps) {
        const oldUserID = this.props.clientID ? this.props.clientID : 0;
        const userID = nextProps.clientID ? nextProps.clientID : 0;

        if (oldUserID !== userID && userID > 0) {
            this.fetchDevices(userID);
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.state !== nextState;
    }

    getStatuscolor(location) {
        switch (location.status) {
            case 1:
                return '#DE6909';
            case 2:
                return '#892fbd';
            case 3:
                return '#1b91f5';
            case 6:
                return '#000000';
            case 4:
                return '#be0000';
            case 5:
                return '#ffd700';
            default:
                return '#9E9E9E';
        }
    }

    componentDidUpdate() {
        let tagsFilterUser = document
            .querySelectorAll('.select-device .ant-select-selection__choice__content');

        if (tagsFilterUser && tagsFilterUser.length > 0) {
            for (let tag of tagsFilterUser) {
                this.state.devices.map((device) => {
                    if (device.name === tag.innerText && device.roadmaps && device.roadmaps.length > 0) {
                        let color = this.getStatuscolor(device.roadmaps[0]);
                        let parentTag = tag.parentElement;

                        if (parentTag && parentTag.style) {
                            parentTag.style.backgroundColor = color;
                        }

                        if (parentTag && parentTag.title) {
                            parentTag.title = '';
                        }
                    }
                });
            }
        }
    }

    fetchDevices = (userID) => {
        if (userID && userID > 0) {
            this.setState({fetching: true});

            fetch(`https://itracking.vn/gapi/v3.0/vehicles/${userID}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Auth-Token': 'AIzaSyAs6DZzfPQGgKsZD28f_nsp5v-D43zi-So',
                }
            })
                .then(response => response.json())
                .then((body) => {
                    if (body.data) {
                        if (body.data.length > 0) {
                            let devices = body.data.filter(device => device.state > 0);
                            let defaultDevices = [];

                            devices.sort((device, nDevice) => {
                                if (device.roadmaps && device.roadmaps.length > 0) {
                                    if (device.roadmaps[0].status === 6 || device.roadmaps[0].status === 5) {
                                        return -1;
                                    }

                                    return 1;
                                }

                                return -1;
                            });

                            if (this.props.defaultDevices && devices && devices.length > 0 && this.props.defaultDevices.length > 0) {
                                let arrDefaultDevices = this.props.defaultDevices.split(',');

                                if (arrDefaultDevices.length > 0) {
                                    defaultDevices = devices.filter((device) => {
                                        for (let i = 0; i < arrDefaultDevices.length; i++) {
                                            if (device.id === arrDefaultDevices[i]) {
                                                device.display = device.name;
                                                device.key = device.id;
                                                device.label = this.renderDevicePopover(device);
                                                if (device.roadmaps && device.roadmaps.length > 0) {
                                                    device.color = this.getStatuscolor(device.roadmaps[0]);
                                                }

                                                return device;
                                            }
                                        }
                                    });
                                }
                            }

                            if (this.state.firstLoad) {
                                this.setState({
                                    devices: defaultDevices,
                                    data: devices,
                                    fetching: false,
                                    firstLoad: false
                                });
                                this.props.handleChange(defaultDevices, 'devices');
                            } else {
                                this.setState({devices: defaultDevices, data: devices, fetching: false});
                                this.props.handleChange([], 'devices');
                            }
                        } else {
                            this.setState({
                                devices: [],
                                data: [],
                                fetching: false,
                                firstLoad: false
                            });

                            this.props.handleChange([], 'devices');
                        }
                    } else {
                        this.setState({
                            devices: [],
                            data: [],
                            fetching: false,
                            firstLoad: false
                        });

                        this.props.handleChange([], 'devices');
                    }
                });
        }
    };

    getLocatonInfo(location, type) {
        if (location.roadmaps && location.roadmaps.length > 0) {
            let roadmap = location.roadmaps[0];
            if (roadmap[type]) {
                return roadmap[type];
            }

            return 'N/A';
        }

        return 'N/A';
    }

    renderDevicePopover(device) {
        let activationTime = moment(device.activation).format('DD-MM-YYYY');
        const content = <div
            style={{
                padding: '20px',
                width: '420px',
                lineHeight: '1.8em'
            }}
            className="popover-device">
            <span style={{display: 'flex'}}>
                <strong>Model : </strong><span>{device.model}</span>
            </span>
            <span style={{display: 'flex'}}>
                <strong>Device ID : </strong> <span>{device.id.trim()}</span>
            </span>
            <span style={{display: 'flex'}}>
                <strong>Activation : </strong> <span>{activationTime}</span>
            </span>
            <span style={{display: 'flex'}}>
                <strong>Sim : </strong> <span>{device.sim}</span>
            </span>
            <span style={{display: 'flex'}}>
                <strong>Sim Info: </strong>
                <span style={{
                    wordWrap: 'break-word',
                    maxWidth: '300px'
                }}>
                    {device.simInfo}
                </span>
            </span>
        </div>;

        const title = <span style={{
            position: 'absolute',
            width: '100%',
            backgroundColor: device.roadmaps && device.roadmaps.length > 0 ?
                this.getStatuscolor(device.roadmaps[0]) : '#ccc',
            height: '55px',
            width: '420px',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            lineHeight: '20px',
            paddingTop: '10px'
        }}>
            {device.roadmaps && device.roadmaps.length > 0 ?
                <span>
                    <span style={{
                        display: 'inline-flex',
                        paddingLeft: '20px',
                        color: '#fff',
                    }}>
                        {device.name}
                    </span>

                    <span style={{
                        display: 'inline-flex',
                        paddingRight: '20px',
                        color: '#fff',
                        fontWeight: 400,
                        fontStyle: 'italic',
                        float: 'right'
                    }}>
                        {device.roadmaps[0].desc}
                    </span>

                    <span style={{
                        display: 'flex',
                        paddingLeft: '20px',
                        color: '#fff',
                        fontSize: '13px',
                    }}>
                        {device.roadmaps[0].duration}
                    </span>
                </span>
                :
                <span style={{
                    display: 'inline-flex',
                    paddingLeft: '20px',
                    color: '#fff',
                    fontWeight: 500,
                }}>{device.name}</span>}
        </span>;

        return <Popover
            placement="right"
            content={content} title={title}>
            <span>{device.name.trim()}</span>
        </Popover>
    }

    render() {
        return (
            <span>
                <Select
                    className={'select-device'}
                    labelInValue
                    value={this.state.devices}
                    size={'large'}
                    mode={'multiple'}
                    style={{textAlign: 'left'}}
                    notFoundContent={'Không tìm thấy!'}
                    placeholder="Chọn thiết bị"
                    optionFilterProp={'children'}
                    filterOption={(input, option) =>
                        option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    onSelect={(value) => {
                        let arrFilterDevices = this.state.data.filter(device => device.id === value.key);
                        let arrDeleteDevices = [];

                        this.state.deDevices.map((deviceID) => {
                            if (deviceID !== value.key) {
                                if (deviceID && deviceID.length > 0) {
                                    arrDeleteDevices.push(deviceID);
                                }
                            }
                        });

                        if (arrFilterDevices && arrFilterDevices.length > 0) {
                            arrFilterDevices[0].key = value.key;
                            arrFilterDevices[0].display = arrFilterDevices[0].name;
                            if (value.label.length > 2) {
                                arrFilterDevices[0].label = this.renderDevicePopover(arrFilterDevices[0]);
                            } else {
                                this.state.data.map((device) => {
                                    if (device.deviceID === value.key) {
                                        arrFilterDevices[0].label = device.name;
                                        arrFilterDevices[0].display = device.name;
                                    }
                                })
                            }

                            if (arrFilterDevices[0].roadmaps && arrFilterDevices[0].roadmaps.length > 0) {
                                arrFilterDevices[0].color = this.getStatuscolor(arrFilterDevices[0].roadmaps[0]);
                            }

                            let arrDevices = [...this.state.devices, arrFilterDevices[0]];

                            this.setState({
                                devices: arrDevices,
                                deDevices: arrDeleteDevices
                            });

                            this.props.handleChange(arrDevices, 'devices');
                        }
                    }}
                    onDeselect={(value) => {
                        let arrDevices = this.state.devices.filter(device => device.key !== value.key);
                        let arrDeleteDevices = this.state.deDevices;

                        this.state.devices.map((device) => {
                            if (device.key === value.key) {
                                if (device.deviceID && device.deviceID.length > 0) {
                                    arrDeleteDevices.push(device.deviceID);
                                } else {
                                    if (parseInt(device.id) !== 0) {
                                        arrDeleteDevices.push(device.id);
                                    }
                                }
                            }
                        });

                        this.setState({
                            devices: arrDevices,
                            deDevices: arrDeleteDevices
                        });

                        this.props.handleChange(arrDevices, 'devices');
                        this.props.handleChange(arrDeleteDevices, 'removeDevices');
                    }}
                >
                    {
                        this.state.data.map(data =>
                            <Select.Option
                                deviceID={data.id === 0 ? data.deviceID : data.id.toString()}
                                value={data.id === 0 ? data.deviceID : data.id.toString()}
                                key={data.name.trim()}>
                                <span style={{
                                    display: 'flex',
                                    position: 'absolute',
                                    top: '25.5px'
                                }}>
                                    <Badge dot style={{
                                        backgroundColor: this.getStatuscolor(data.roadmaps
                                        && data.roadmaps.length > 0 ? data.roadmaps[0] : {status: 0}),
                                    }}/>
                                </span>

                                <p style={{
                                    display: 'inline-flex',
                                    fontWeight: 500,
                                    marginLeft: '18px'
                                }}
                                   className="device-name">{data.name.trim()}
                                </p>

                                <p style={{
                                    display: 'inline-flex',
                                    float: 'right',
                                    fontStyle: 'italic',
                                    marginRight: '20px'
                                }}
                                >
                                    {this.getLocatonInfo(data, 'desc')}
                                </p>

                                <p style={{
                                    marginLeft: '18px'
                                }}>
                                    {this.getLocatonInfo(data, 'duration')}
                                </p>
                            </Select.Option>)
                    }
                </Select>
                {
                    this.state.fetching ?
                        <Spin size="small" style={{position: 'absolute', top: '3px', right: '13px'}}/> : null
                }
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/itracking/select-devices.js